import { CreateExperienceMutationProvider } from "__legacy/queries/experiences/CreateExperienceMutationProvider";
import { StakeholderQueryProvider } from "__legacy/queries/stakeholders/StakeholderQueryProvider";
import { Button, Form, Layout, PageHeader } from "antd";
import { Fragment, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

import { ExperienceForm, onError, onFinish } from "./ExperienceForm";

export const New: React.FC<{}> = () => {
  const { stakeholderId } = useParams();
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [errors, setErrors] = useState<string[]>([]);

  return (
    <StakeholderQueryProvider variables={{ id: stakeholderId }}>
      {({ stakeholder }) => (
        <CreateExperienceMutationProvider onError={onError(form, setErrors)} onCompleted={() => navigate("../")}>
          {(loading, mutate) => (
            <Fragment>
              <PageHeader
                ghost={true}
                title={`New experience for stakeholder ${stakeholder.companyName}`}
                extra={
                  <Fragment>
                    <Button onClick={() => navigate("../")}>Back to experiences</Button>
                    <Button type="primary" loading={loading} onClick={() => form.submit()}>
                      Save
                    </Button>
                  </Fragment>
                }
              />
              <Layout.Content className="content">
                <ExperienceForm
                  action="create"
                  form={form}
                  handler={onFinish(mutate, { stakeholderId }, {})}
                  values={{}}
                  errors={errors}
                />
              </Layout.Content>
            </Fragment>
          )}
        </CreateExperienceMutationProvider>
      )}
    </StakeholderQueryProvider>
  );
};
